import { Menu, MenuHeader, MenuItem } from "@szhsin/react-menu";
import * as React from "react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { BOT_LEVELS, BotLevel, getBotLevelTextKey, getLastBotLevel, setLastBotLevel } from "@mancala/core";
import { Context } from "../context/context";
import { BotIcon } from "./Icons";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css"

// "Play with bot": a menu of the levels, the one chosen last marked. `className` styles the button: the header's hides on phones, the home page's row of actions shows it there.
const BotLevelMenu: FunctionComponent<{ context: Context, onChoose: (level: BotLevel) => void, className?: string, label?: string }> = ({ context, onChoose, className, label }) => {
    const { t } = useTranslation();
    const lastLevel = getLastBotLevel(context.storage);
    const menuButton = (
        <button className={className ?? "btn ghost"}>
            <BotIcon />{label ?? t("PlayWithBot")}
        </button>
    );
    const choose = (level: BotLevel) => {
        setLastBotLevel(context.storage, level);
        onChoose(level);
    };
    return (
        <Menu menuButton={menuButton} transition align="end" offsetY={8}>
            <MenuHeader>{t("ChooseBotLevel")}</MenuHeader>
            {BOT_LEVELS.map((level) => (
                <MenuItem key={level} type="checkbox" checked={level === lastLevel} onClick={() => choose(level)}>
                    {t(getBotLevelTextKey(level))}
                </MenuItem>
            ))}
        </Menu>
    );
};

export default BotLevelMenu;
